import { useEffect } from 'react';

/** Kaydırma sırasında ağır animasyonları duraklatır — takılmayı azaltır */
const ScrollPerf = () => {
  useEffect(() => {
    let endTimer;
    const onScroll = () => {
      document.body.classList.add('is-scrolling');
      window.clearTimeout(endTimer);
      endTimer = window.setTimeout(() => {
        document.body.classList.remove('is-scrolling');
      }, 180);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.clearTimeout(endTimer);
      document.body.classList.remove('is-scrolling');
    };
  }, []);

  return null;
};

export default ScrollPerf;
